import React, { useState } from "react";
import LeftPanel from "./LeftPanel";
import { Line } from 'react-chartjs-2';
import {
  FaSearch
 
} from "react-icons/fa";
import {
  
  Chart,
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  LineElement,
  PointElement,
  LineController,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

import { FaDownload, FaChevronDown, FaFilePdf } from 'react-icons/fa';
import { AiOutlineBarChart } from "react-icons/ai";
import { SiMicrosoftexcel } from "react-icons/si";
import Header from "./Header";
import Footer from "./Footer";

Chart.register(
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  LineElement,
  LineController,
  PointElement,
  Title,
  Tooltip,
  Legend
);

function Dashboard() {
  const [selectedPeriod, setSelectedPeriod] = useState('Month');

  const [openSections, setOpenSections] = useState({
    electricity1: true,
    electricity2: false,
    electricity3: false,
  });

  const toggleAccordion = (section) => {
    setOpenSections(prevState => ({
      ...prevState,
      [section]: !prevState[section]
    }));
  };

  const data = {
    labels: ['Aug-2014', 'Sep-2014', 'Oct-2014', 'Nov-2014', 'Dec-2014', 'Jan-2015', 'Feb-2015', 'Mar-2015', 'Apr-2015', 'May-2015', 'Jun-2015', 'Jul-2015'],
    datasets: [
      {
        label: 'Monthly Sales (Units)',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 17, 15, 25],
        backgroundColor: 'rgba(122, 188, 50, 0.2)',
        borderColor: '#7ABC32',
        borderWidth: 1.5,
        type: 'bar',
        yAxisID: 'y1',
        borderRadius: 6,
      },
      {
        label: 'Greenhouse gas',
        data: [null, null, null, null, null, null, null, null, null, 0.018, 0.015, 0.032],
        borderColor: '#F78200',
        backgroundColor: 'rgba(247, 130, 0, 0.1)',
        borderWidth: 0,
        pointRadius: 6,
        pointHoverRadius: 8,
        pointBackgroundColor: '#F78200',
        type: 'line',
        yAxisID: 'y2',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: false,
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        titleColor: '#fff',
        bodyColor: '#fff',
        borderColor: 'rgba(255, 255, 255, 0.1)',
        borderWidth: 1,
        padding: 12,
        bodySpacing: 8,
        cornerRadius: 8,
        displayColors: false,
        callbacks: {
          title: () => '',
          label: (context) => {
            const label = context.dataset.label || '';
            const value = context.parsed.y || 0;
            return `${label}: ${value}`;
          }
        }
      },
      legend: {
        position: 'top',
        labels: {
          color: '#1c1c1e',
          font: {
            size: 13,
            weight: '500'
          },
          padding: 16,
          usePointStyle: true,
        }
      }
    },
    scales: {
      y1: {
        type: 'linear',
        position: 'left',
        grid: {
          drawOnChartArea: true,
          color: 'rgba(0, 0, 0, 0.05)'
        },
        ticks: {
          color: '#636366',
          padding: 8,
          stepSize: 5,
          max: 25,
        },
        title: {
          display: true,
          text: 'Average Monthly Consumption (KWH)',
          color: '#1c1c1e',
          font: {
            size: 12,
            weight: '500'
          }
        },
      },
      y2: {
        type: 'linear',
        position: 'right',
        stepSize: 0.005,
        min: 0,
        max: 0.035,
        grid: {
          drawOnChartArea: false,
        },
        ticks: {
          color: '#636366',
          padding: 8,
        },
        title: {
          display: true,
          text: 'Greenhouse gas (tonnes)',
          color: '#1c1c1e',
          font: {
            size: 12,
            weight: '500'
          }
        },
      },
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: '#636366',
          padding: 8,
        },
        title: {
          display: true,
          text: 'Average Consumption',
          color: '#1c1c1e',
          font: {
            size: 12,
            weight: '500'
          }
        },
      },
    },
  };

  const renderSection = (sectionKey, title) => {
    const isOpen = openSections[sectionKey];
    return (
      
      <div className="border border-gray-200 rounded-2xl shadow-sm bg-white w-full overflow-hidden mt-4">
        <button
          className="w-full text-left px-6 py-5 flex justify-between items-center transition-colors duration-200"
          onClick={() => toggleAccordion(sectionKey)}
        >
          <div className="flex items-center space-x-3">
            {!isOpen && (
              <>
                <div className="w-3 h-3 rounded-full bg-[#002060]"></div>
                <p className="text-[15px] font-semibold text-gray-900">
                  {title}
                </p>
              </>
            )}
          </div>
          <FaChevronDown
            className={`text-gray-500 transform transition-transform duration-300 ${
              isOpen ? 'rotate-180' : ''
            }`}
          />
        </button>
        {isOpen && (
          <div className="p-6 -mt-10 text-gray-900">
            <div className="grid grid-cols-[auto_1fr] gap-x-6">
              <span className="text-base font-semibold text-gray-900 mb-1">Electricity</span>
              <span>{title.replace('ELECTRICITY', '')}</span>

              <span className="text-base font-semibold text-gray-900 mb-1">NMI</span>
              <span>6203642120</span>
              <span className="text-base font-semibold text-gray-900 mb-1">ADDRESS</span>
              <span>Rear 145 Fitzgerald Rd, Laverton North, VIC 3029</span>
              <span className="text-base font-semibold text-gray-900 mb-1">LNSP</span>
              <span>Powercor</span>
            </div>
            <div className="p-6 border-t border-gray-100 flex flex-col lg:flex-row gap-6">
              <div className="w-full lg:w-3/4 h-96">
                <Line data={data} options={options} />
              </div>
              <div className="w-full lg:w-1/4 flex flex-col space-y-6">
                <div className="bg-gray-50 p-5 rounded-xl space-y-4">
                  <div>
                    <h3 className="text-sm font-semibold text-gray-900 mb-1">Consumption Snapshot</h3>
                    <p className="text-xs text-gray-500 flex items-center ">
                      <span>Most recent bill (Aug-15)</span>
                      <FaDownload className="w-3 h-3  text-blue-500 ml-auto" />
                    </p>
                    <div className="mt-3 px-4 py-2.5 bg-[#002060] text-white rounded-lg text-sm font-medium shadow-sm flex items-center justify-center">
                      24.987 KWH
                    </div>
                  </div>
                  <div className="pt-4 border-t border-gray-200">
                    <h3 className="text-sm font-semibold text-gray-900 mb-1">Contract expires</h3>
                    <p className="text-xs text-gray-500 flex items-center">
                      <span>Shell Energy</span>
                      <FaDownload className="w-3 h-3 text-blue-500 ml-auto " />
                    </p>
                    <div className="mt-3 px-4 py-2.5 bg-[#002060] text-white rounded-lg text-sm font-medium flex items-center justify-center">
                      297 Days
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-100 p-6 bg-gray-50">
              <h2 className="text-lg font-semibold text-gray-900 mb-6">Energy Reports</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
              {[
  { title: "Interval Data", description: "Energy Usage in 30 minutes interval", color: "bg-blue-500", showChart: true, showExcel: true, showPdf: false },
  { title: "Bill Validation", description: "Demand data including kW, kVA and Power Factor", color: "bg-green-500", showChart: true, showExcel: true, showPdf: false },
  { title: "Energy Management", description: "Report detailing usage patterns and demand.", color: "bg-orange-500", showChart: false, showExcel: false, showPdf: true },
  { title: "Retailer Bill", description: "Download copies of the retailer’s bills", color: "bg-purple-500", showChart: false, showExcel: false, showPdf: true }
].map((section, index) => (
  <div key={index} className="bg-white p-5 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col justify-between">
    <div>
      <h3 className="text-base font-semibold text-gray-900 mb-1">{section.title}</h3>
      <p className="text-sm text-gray-600">{section.description}</p>
    </div>
    <div className="flex space-x-3 mt-4">
      <FaDownload className="text-[#7ABC32] hover:text-[#7ABC32]-700 cursor-pointer transition-colors" />
      {section.showChart && (
        <AiOutlineBarChart className="text-[#7ABC32] hover:text-[#7ABC32]-700 w-5 h-5 cursor-pointer transition-colors" />
      )}
      {section.showExcel && (
        <SiMicrosoftexcel className="text-[#304914] hover:text-[#7ABC32]-700 cursor-pointer transition-colors" />
      )}
      {section.showPdf && (
        <FaFilePdf className="text-[#df6f3b] hover:text-[#7ABC32]-700 cursor-pointer transition-colors" />
      )}
    </div>
  </div>
))}
              </div>
              <div className="bg-white p-5 rounded-xl shadow-sm flex flex-col md:flex-row items-center justify-between gap-4">
                <div className="space-y-1">
                  <h3 className="text-base font-semibold text-gray-900">Interval Data Report</h3>
                  <p className="text-sm text-gray-600">Select period to generate report</p>
                </div>
                <div className="flex items-center gap-3 w-full md:w-auto">
                  <select
                    className="w-full md:w-48 px-4 py-2.5 text-sm border border-gray-200 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    value={selectedPeriod}
                    onChange={(e) => setSelectedPeriod(e.target.value)}
                  >
                    <option value="Month">Month</option>
                    <option value="Last 6 Months">Last 6 Months</option>
                    <option value="Last 12 Months">Last 12 Months</option>
                    <option value="This Year">This Year</option>
                    <option value="Last Year">Last Year</option>
                  </select>
                  <button className="w-full md:w-auto px-5 py-2.5 bg-[#7ABC32] hover:bg-[#70a534] text-white text-sm font-medium rounded-lg flex items-center justify-center gap-2 transition-colors">
                    <FaDownload className="w-4 h-4" />
                    DOWNLOAD REPORT
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    
    <div className="min-h-screen flex flex-col bg-gray-50 font-[system-ui]">
    
      
      <div className="flex flex-grow">
      <div className="w-[20%]"></div>
      
      <LeftPanel title="DASHBOARD" />
       
        <div className="w-[60%] px-6 py-8 overflow-y-auto">
        <div className="flex justify-end">
            <div className="flex items-center mb-6">
              <button className="bg-[#7ABC32] text-white px-3 py-1 rounded-l-md">
                Search by Account
              </button>
              <div className="relative w-80">
                <input
                  type="text"
                  placeholder="Account Number or NMI/Meter"
                  className="w-full sm:w-90 px-3 py-1 border rounded-r-md focus:outline-none focus:ring-0 focus:ring-[#7ABC32] italic"
                />
                <FaSearch
                  className="absolute right-1 top-2.5 text-blue-500 cursor-pointer"
                  size={15}
                  title="Search"
                />
              </div>
            </div>
          </div>
      
          {renderSection('electricity1', 'ELECTRICITY EN 145 Fitzgerald Rd')}
          {renderSection('electricity2', 'ELECTRICITY PAD SITE 145 Fitzgerald Rd')}
          {renderSection('electricity3', 'ELECTRICITY  Rear 145 Fitzgerald Rd')}
        </div>
        <div className="w-[20%]"></div>
      </div>
     
    </div>
  );
}

export default Dashboard;